<template>
    <div v-if="course" class="courses-single-page">

        <div class="container my-container no-padding-left pt-4">
            <div class="container">
                <div class="row content-page-wrap ">
                    <div class="col-lg-8 col-12">
                        <div class="clearfix">
                            <div class="course-single">
                                <div class="content">
                                    <h1 class="course-title accent-primary-tx">{{ course.name }}</h1>

                                    <p>
                                        {{ course.category }}
                                    </p>
                                    <p>
                                        {{ course.descriptionShort }}
                                    </p>
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-12">
                        <div class="clearfix">
                            <div class="course-single">
                                <div class="featured-post">
                                    <div class="entry-image">
                                        <i class="fa fa-5x fa-image mt-3" v-if="!course.imageFileName"></i>
                                        <img v-else :src="course | s3url" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row content-page-wrap">
                    <div class="clearfix">
                        <div class="course-single">
                            <div class="content">
                                <div v-if="course.author" class="row author-price">
                                    <div class="author col-lg-4 col-12">
                                        <div class="avatar">
                                            <i class="fa fa-5x fa-image" v-if="!course.author.imageFileName"></i>
                                            <img v-else :src="course.author | s3url" alt="images" style="max-width: 120px">
                                        </div>
                                        <div class="info">
                                            <div class="name text-nowrap mt-2">
                                                <a href="#">{{ course.author.firstName }} {{ course.author.lastName }}</a>
                                            </div>
                                            <div class="job">
                                                {{ course.author.jobTitle }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-8 col-12" v-html="course.author.bio">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div v-if="courseDetails" class="container my-container no-padding-left">
            <div v-if="courseDetails" class="row">
                <div id="collapsable" class="col-lg-3 col-12 no-padding-left">
                    <div>
                        <div v-if="currentChapterIndex < 0" v-on:click="changeSelection(0, 0)">
                            <h1 class="chapter-disabled toggle-colour">Course Contents</h1>
                        </div>
                        <div v-else>
                            <h1 class="course-contents-title-class accent-primary-tx accent-primary-bg">Course Contents</h1>
                            <div id="modules-toggle">
                                <div class="module" v-for="(chapter, idx) in courseDetails.chapters" :key="idx">
                                    <div v-if="idx == currentChapterIndex">
                                        <h2 class="module-title-selected accent-secondary-tx">{{ chapter.name }}</h2>
                                        <ul>
                                            <li class="lesson-number">{{ currentPageIndex + 1 }}/{{chapter.pages.length}} Lessons</li>
                                            <li v-for="(page, pIdx) in chapter.pages" class="lesson-title" v-on:click="changeSelection(idx, pIdx)" :key="pIdx">

                                                <img v-if="pIdx == currentPageIndex" class="lesson-box" src="/wwwroot/images/course-details/checked-box.png" />
                                                <img v-if="pIdx != currentPageIndex && page.userCompleted" class="lesson-box" src="/wwwroot/images/course-details/checked-completed-box.png" />
                                                <img v-if="pIdx != currentPageIndex && !page.userCompleted" class="lesson-box" src="/wwwroot/images/course-details/unchecked-box.png" />

                                                <span class="page-name">{{ page.name }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-else v-on:click="changeSelection(idx, 0)">
                                        <h2 class="module-title-non-selected">{{ chapter.name }}</h2>
                                    </div>

                                    <hr class="module-dividing-line">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div v-if="currentChapterIndex == -1" v-on:click="changeSelection(-1, 0)">
                            <h1 class="course-contents-title-class">Certificate</h1>
                        </div>
                        <div v-else v-on:click="changeSelection(-1, 0)">
                            <h1 class="chapter-disabled toggle-colour">Certificate</h1>
                        </div>
                    </div>
                    <div v-if="isCourseFacilitated">
                        <div v-if="currentChapterIndex == -2" v-on:click="changeSelection(-2, 0)">
                            <h1 class="course-contents-title-class">Attendees</h1>
                        </div>
                        <div v-else v-on:click="changeSelection(-2, 0)">
                            <h1 class="chapter-disabled toggle-colour">Attendees</h1>
                        </div>
                    </div>
                </div>

                <!--------------- content-section --------------->
                <div id="content-section" class="col-lg-9 col-12">
                    <div class="module-section">
                        <div class="content-page-wrap clearfix">
                            <div v-if="canNavigateBy(-1)" v-on:click="navigateBy(-1)" id="previous-lesson-action-3" class="previous-arrow-container">
                                <img id="toggle-arrow-previous" class="previous-arrow-img" src="/wwwroot/images/course-details/previous-arrow.png" />
                                <a class="previous-arrow-text">PREVIOUS</a>
                            </div>
                            <div v-if="canNavigateBy(1)" v-on:click="navigateBy(1)" id="next-lesson-action-3" class="next-arrow-container">
                                <a class="next-arrow-text">NEXT</a>
                                <img class="next-arrow-img" src="/wwwroot/images/course-details/next-arrow.png" />
                            </div>
                        </div>

                        <!--------------- course content --------------->
                        <div class="lesson-content-section">

                            <span id="annotation-dialog" class="annotation__content">
                                <p>[sex·y] /'seksē/</p>
                                <p><em>informal</em></p>
                                <p>exciting; appealing. <a href="www.google.com" target="_blank">link</a></p>
                            </span>

                            <div class="no-content pb-5" v-if="currentChapterIndex >= 0 && courseDetails.chapters.length < 1">
                                <div class="title text-center">
                                    <h5>
                                        No content yet! <br />Check back later
                                    </h5>
                                </div>
                            </div>
                            <div class="module" v-for="(chapter, idx) in courseDetails.chapters" v-if="idx == currentChapterIndex" :key="idx">
                                <h1 class="module-title accent-secondary-tx">{{ chapter.name }}</h1>

                                <div v-for="(page, pIdx) in chapter.pages" class="lesson-title" v-if="pIdx == currentPageIndex" :key="pIdx">
                                    <!--  <h3 class="lesson-title">{{ page.name }}</h3>-->
                                    <br />

                                    <div v-for="(component, cIdx) in page.components">
                                        <div v-if="component.type == 'html'">
                                            <span class="accent-secondary-tx" v-html="component.html"></span>
                                        </div>

                                        <div v-if="component.type == 'image'" v-bind:style="{'margin-left': component.alignmentY + 'px', 'margin-top': component.alignmentX + 'px'}">
                                            <h5>{{ component.name }} </h5>
                                            <img v-bind:src="component | s3url" />
                                            <p>{{component.description}}</p>
                                        </div>

                                        <div v-if="component.type == 'text'">
                                            <div class="content" v-html="component.html">
                                            </div>
                                        </div>

                                        <div v-if="component.type == 'video'" v-bind:style="{'margin-left': component.alignmentY + 'px', 'margin-top': component.alignmentX + 'px'}">
                                            <h5>{{ component.name}} </h5>
                                            <div class="plyr-video">
                                                <vue-plyr>
                                                    <video v-bind:src="component | s3url">
                                                    </video>
                                                </vue-plyr>
                                            </div>
                                            <p>{{ component.description}} </p>

                                        </div>
                                        <div v-if="component.type == 'pdf'">
                                            <PDFJSViewer :fileName="component | s3url('')" />
                                        </div>

                                        <div v-if="component.type == 'scorm'">
                                            <ScormViewer :course="course" :courseDetails="courseDetails" :component="component" v-on:windowOpened="selectScormComponent(component)" v-on:windowClosed="reloadCourse"></ScormViewer>
                                        </div>

                                        <div class="question-container" v-if="component.type == 'question'">
                                            <div style="margin-bottom: 10px; font-weight: bold;">Question {{ cIdx + 1 }}</div>
                                            <div class="question-text" v-html="component.questionText"></div>
                                            <div>
                                                <div class="question-points" v-if="component.totalPoints > 0">
                                                    <span v-bind:class="{ question_success: (component.userAnswerIndexes.length == component.totalPoints) }">
                                                        {{ component.userAnswerIndexes.length }}/{{ component.totalPoints }} answers selected
                                                    </span>
                                                </div>

                                                <div v-for="(answer, i) in component.answers">
                                                    <label>
                                                        <input v-if="component.totalPoints == 1"
                                                               type="radio"
                                                               :name="component.id"
                                                               :value="i"
                                                               :disabled="page.userCompleted"
                                                               v-model="component.userAnswerIndexes[0]" />
                                                        <input v-else
                                                               type="checkbox"
                                                               :name="component.id"
                                                               :value="i"
                                                               :disabled="page.userCompleted"
                                                               v-model="component.userAnswerIndexes" />
                                                        {{ answer.answerText }}
                                                        <span class="text-success" v-if="page.userCompleted && answer.isCorrect && component.userAnswerIndexes.indexOf(i) > -1">(Correct answer)</span>
                                                        <span class="text-danger" v-if="page.userCompleted && answer.isCorrect && component.userAnswerIndexes.indexOf(i) == -1">(Correct answer)</span>
                                                    </label>
                                                </div>
                                                <div v-if="page.userCompleted && component.solutionText && component.solutionText.length" style="margin-top: 15px;" class="">
                                                    <span v-html="component.solutionText" class="text-success"></span>
                                                </div>
                                            </div>
                                            <hr />
                                        </div>
                                        <br />
                                    </div>
                                    <br />
                                    <button v-if="page.hasQuestions && !page.userCompleted && !page.hasScorm" v-on:click="submit(page)" class="btn-success">Submit</button>
                                    <div v-if="page.hasQuestions && page.userCompleted">
                                        <span v-if="!page.userCompleted">Not completed (Required: {{ page.minimumPercentagePassMark }}%)</span>
                                        <span v-else-if="!page.userPassed && page.totalPoints > 0" class="text-danger">
                                            Failed<br />
                                            Score: {{page.userTotalCorrect}}/{{page.totalPoints}} = {{ page.userScore }}%<br />
                                            Completed: {{ moment(page.userCompleteDate).format("DD MMMM YYYY HH:mm:SS") }}
                                        </span>
                                        <span v-else class="text-success">
                                            <span v-if="page.totalPoints > 0">
                                                Passed<br />
                                                Score: {{page.userTotalCorrect}}/{{page.totalPoints}} = {{ page.userScore }}% <br />
                                            </span>
                                            Completed: {{ moment(page.userCompleteDate).format("DD MMMM YYYY HH:mm:SS") }}
                                        </span>
                                    </div>
                                    <hr style="border: solid black thin">
                                </div>
                            </div>

                            <div class="module" v-if="currentChapterIndex == -1">
                                <h1 class="module-title">Grades</h1>
                                <div class="tab-content">
                                    <div class="item-content">
                                        <div class="access-sg text clearfix">

                                            <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Chapter</th>
                                                        <th>Quiz</th>
                                                        <th>Weight</th>
                                                        <th>Result</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="!courseDetails.migratedResults">
                                                    <fragment v-for="(chapter, idx) in courseDetails.chapters" :key="idx">
                                                        <tr v-for="(page, pIdx) in chapter.pages" v-if="page.percentageWeight > 0" :key="pIdx">
                                                            <td>
                                                                {{ chapter.name }}
                                                            </td>
                                                            <td>
                                                                {{ page.name }}
                                                            </td>
                                                            <td>
                                                                {{ page.percentageWeight }}
                                                            </td>
                                                            <td>
                                                                <span v-if="!page.userCompleted">Not completed (Required: {{ page.minimumPercentagePassMark }}%)</span>
                                                                <span v-else-if="!page.userPassed" class="text-danger">
                                                                    Failed<br />
                                                                    Score: <span v-if="page.totalPoints">{{page.userTotalCorrect}}/{{page.totalPoints}} = </span>{{ page.userScore }}% <br />
                                                                    Completed: {{ moment(page.userCompleteDate).format("DD MMMM YYYY HH:mm:SS") }}
                                                                </span>
                                                                <span v-else class="text-success">
                                                                    Passed<br />
                                                                    Score: <span v-if="page.totalPoints">{{page.userTotalCorrect}}/{{page.totalPoints}} = </span>{{ page.userScore }}% <br />
                                                                    Completed: {{ moment(page.userCompleteDate).format("DD MMMM YYYY HH:mm:SS") }}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </fragment>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colspan="3">
                                                            <span v-if="!courseDetails.userCompleted" class="final-result">
                                                                Not completed
                                                            </span>
                                                            <span v-else-if="courseDetails.userPassed" class="text-success final-result">
                                                                Passed!
                                                            </span>
                                                            <span v-else class="text-danger final-result">
                                                                Failed
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span v-if="!courseDetails.userCompleted" class="final-result">
                                                                Not completed
                                                            </span>
                                                            <span v-else-if="courseDetails.userPassed" class="text-success final-result">
                                                                {{ courseDetails.userScore }}%
                                                            </span>
                                                            <span v-else class="text-danger final-result">
                                                                {{ courseDetails.userScore }}% (Required: {{ courseDetails.minimumPercentagePassMark }}%)
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                            </div>
                                            <button v-if="courseDetails.userPassed && !isCourseFacilitated" v-on:click="downloadCertificate">Download certificate</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="module" v-if="currentChapterIndex == -2 && isCourseFacilitated">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h1 class="module-title">Attendees</h1>
                                    <button type="button" class="btn-site-primary attendees-add-button" v-on:click="openAttendeeModal()">+</button>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-bordered attendees-table">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Company</th>
                                                <th>Facility / Site</th>
                                                <th>Email</th>
                                                <th>Number</th>
                                                <th>Employee ID</th>
                                                <th>ID / Passport</th>
                                                <th>Date</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="attendees.length < 1">
                                                <td colspan="9" class="text-center">No attendees captured yet</td>
                                            </tr>
                                            <tr v-for="attendee in attendees" :key="attendee.id">
                                                <td>{{ attendee.name }} {{ attendee.surname }}</td>
                                                <td>{{ attendee.company }}</td>
                                                <td>{{ attendee.facilitySite }}</td>
                                                <td>{{ attendee.email }}</td>
                                                <td>{{ attendee.number }}</td>
                                                <td>{{ attendee.employeeId }}</td>
                                                <td>{{ attendee.idNumber }}</td>
                                                <td>{{ formatDate(attendee.date) }}</td>
                                                <td class="text-nowrap">
                                                    <button type="button" class="attendee-icon-button attendee-certificate" title="Certificate" v-if="hasCertificate" v-on:click="downloadAttendeeCertificate(attendee)"><i class="fa fa-certificate"></i></button>
                                                    <button type="button" class="attendee-icon-button attendee-edit" title="Edit" v-on:click="openAttendeeModal(attendee)"><i class="fa fa-pencil"></i></button>
                                                    <button type="button" class="attendee-icon-button attendee-remove" title="Remove" v-on:click="removeAttendee(attendee)"><i class="fa fa-trash"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="content-page-wrap clearfix">
                            <div v-if="canNavigateBy(-1)" v-on:click="navigateBy(-1)" id="previous-lesson-action-3" class="previous-arrow-container">
                                <img id="toggle-arrow-previous" class="previous-arrow-img" src="/wwwroot/images/course-details/previous-arrow.png" />
                                <a class="previous-arrow-text">PREVIOUS</a>
                            </div>
                            <div v-if="canNavigateBy(1)" v-on:click="navigateBy(1)" id="next-lesson-action-3" class="next-arrow-container">
                                <a class="next-arrow-text">NEXT</a>
                                <img class="next-arrow-img" src="/wwwroot/images/course-details/next-arrow.png" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div v-if="showSubmissionError" id="error-modal" class="modal in" tabindex="-1" role="dialog" aria-hidden="true">

            <div style="text-align: center; position: absolute; top: 40%; width: 100%">

                <p style="color: white;">
                    You have not completed all questions correctly.<br />
                    Kindly review your submission and ensure all possible marks have been awarded
                </p>
                <br />
                <button style="min-width: 230px;" v-on:click="showSubmissionError=false" class="btn btn-danger">Ok</button>
            </div>
        </div>

        <div v-if="confirmationPage != null" id="confirmation-modal" class="modal in" tabindex="-1" role="dialog" aria-hidden="true">

            <div style="text-align: center; position: absolute; top: 30%; width: 100%">
                <h1 style="font-size: 24px; color:white;">{{ confirmationPage.name }}</h1>
                <br />
                <p style="color: white;">
                    You're about to submit your evaluation.<br />
                    The action is final and irreversable. Ensure you've reviewed your submission and click "Submit" to continue;
                </p>
                <br />
                <button style="min-width: 230px; margin-bottom: 15px;" v-on:click="confirmationPage = null" class="btn btn-info">Cancel</button>
                <br />
                <button style="min-width: 230px;" v-on:click="confirmSubmit" class="btn btn-danger">Submit</button>
            </div>
        </div>

        <div v-if="scormComponent != null" id="scorm-modal" class="modal in" tabindex="-1" role="dialog" aria-hidden="true">
            <div style="text-align: center; position: absolute; top: 30%; width: 100%">
                <h1 style="font-size: 32px; color:white;" class="accent-secondary-tx">{{ scormComponent.name }}</h1>
                <br />
                <p style="color: white;font-size: 28px;">
                    We've launched your course module in a separate browser window.<br />
                    Please close the module browser window to continue.
                </p>
                <br />
            </div>
        </div>

        <div v-if="attendeeModalOpen" id="attendee-modal" class="modal in" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="attendee-modal-card">
                <h1>{{ attendeeForm.id ? "Edit attendee" : "Add attendee" }}</h1>
                <div class="row">
                    <div class="col-md-6">
                        <label>Name *</label>
                        <input v-model="attendeeForm.name" type="text" v-bind:class="{ 'not-valid': attendeeValidation.name }" />
                    </div>
                    <div class="col-md-6">
                        <label>Surname *</label>
                        <input v-model="attendeeForm.surname" type="text" v-bind:class="{ 'not-valid': attendeeValidation.surname }" />
                    </div>
                    <div class="col-md-6">
                        <label>Company *</label>
                        <input v-model="attendeeForm.company" type="text" v-bind:class="{ 'not-valid': attendeeValidation.company }" />
                    </div>
                    <div class="col-md-6">
                        <label>Facility / Site</label>
                        <input v-model="attendeeForm.facilitySite" type="text" />
                    </div>
                    <div class="col-md-6">
                        <label>Email</label>
                        <input v-model="attendeeForm.email" type="email" />
                    </div>
                    <div class="col-md-6">
                        <label>Contact Number</label>
                        <input v-model="attendeeForm.number" type="text" />
                    </div>
                    <div class="col-md-6">
                        <label>Employee ID Number</label>
                        <input v-model="attendeeForm.employeeId" type="text" />
                    </div>
                    <div class="col-md-6">
                        <label>Attendance Date *</label>
                        <input v-model="attendeeForm.date" type="date" v-bind:class="{ 'not-valid': attendeeValidation.date }" />
                    </div>
                    <div class="col-md-6">
                        <label>ID / Passport Number</label>
                        <input v-model="attendeeForm.idNumber" type="text" />
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-4">
                    <button type="button" class="btn btn-danger mr-2" v-on:click="closeAttendeeModal">Cancel</button>
                    <button type="button" class="btn-site-primary" v-on:click="saveAttendee">Save</button>
                </div>
            </div>
        </div>
    </div><!-- courses-single -->
</template>
<style>

    /*Style overrides for course content body - mostly to make edx imports look ok */
    .final-result {
        font-size: 20px;
        font-weight: 600;
    }

    .lesson-content-section li {
        color: black;
        font-size: 14px;
    }

    .lesson-content-section td {
        color: black;
        font-size: 14px;
    }

    .lesson-content-section ul {
        list-style: disc !important;
        list-style: disc !important;
        padding-left: 20px;
    }

    .lesson-content-section p {
        color: black;
        font-size: 14px;
        margin-bottom: 20px;
    }

    .lesson-content-section h1 {
        font-size: 28px;
        margin-bottom: 15px;
    }

    .lesson-content-section b {
        font-weight: bold;
    }

    .lesson-content-section strong {
        font-weight: bold;
    }


    /* annotation */
    .annotation {
        color: #607b71 !important;
        cursor: pointer;
        text-decoration: underline !important;
        display: inline;
        -webkit-perspective: 500px;
        -moz-perspective: 500px;
        perspective: 500px;
    }

    .annotation__content {
        transition: all 200ms ease;
        transform: translate3d(-50%, 0%, 0);
        transform-origin: 0 10px;
        background-color: #fff;
        border-radius: 4px;
        color: #2f2f2f;
        font-size: 12px !important;
        font-weight: normal;
        padding: 10px 20px;
        pointer-events: none;
        text-align: left;
        border-color: grey;
        border-style: solid;
        border-width: 0.5px;
        position: fixed;
        width: 40%;
        opacity: 0;
    }

        .annotation__content p {
            font-size: 10px !important;
        }

        .annotation__content:before {
            border-color: transparent;
            border-top-color: black;
            border-style: solid;
            border-width: 10px;
            content: ' ';
            display: block;
            height: 0;
            left: 50%;
            margin-left: -10px;
            position: absolute;
            bottom: -20px;
            width: 0;
        }

        .annotation__content:after {
            content: ' ';
            display: block;
            position: absolute;
            bottom: -20px;
            left: 0;
            width: 100%;
            height: 20px;
        }

        .annotation__content:hover {
            -webkit-transform: rotateX(0deg) translate3d(-50%, -10%, 0);
            -moz-transform: rotateX(0deg) translate3d(-50%, -10%, 0);
            -ms-transform: rotateX(0deg) translate3d(-50%, -10%, 0);
            -o-transform: rotateX(0deg) translate3d(-50%, -10%, 0);
            transform: rotateX(0deg) translate3d(-50%, -10%, 0);
            opacity: 1;
            pointer-events: auto;
        }

    .annotation-box {
        display: none;
    }
</style>

<style scoped>


    .course-title {
        margin-top: 20px;
        font-size: 24px;
        color: #333;
        font-weight: 500;
    }

    .plyr-video {
        margin: 0 auto;
        max-width: 80%;
    }

    .item-content h5 {
        text-align: center;
        margin-top: 3px;
    }

    #error-modal {
        display: block;
        z-index: 99999;
        background-color: rgba(61, 9, 9, 0.98);
    }

    #confirmation-modal {
        display: block;
        z-index: 99999;
        background-color: rgba(9, 61,10, 0.98);
    }

    #scorm-modal {
        display: block;
        z-index: 99999;
        background-color: rgba(9, 61,10, 0.98);
    }

    #attendee-modal {
        display: block;
        z-index: 99999;
        background-color: rgba(22, 9, 61, 0.72);
    }

    .attendee-modal-card {
        background-color: white;
        border-radius: 8px;
        color: #222;
        left: 50%;
        max-width: 760px;
        padding: 28px;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 40px);
    }

    .attendee-modal-card h1 {
        color: #282d69;
        font-size: 24px;
        margin-bottom: 20px;
    }

    .attendee-modal-card label {
        color: #282d69;
        display: block;
        font-weight: 600;
        margin-bottom: 4px;
        margin-top: 10px;
    }

    .attendee-modal-card input {
        border: 1px solid #d9dce7;
        border-radius: 4px;
        color: #222;
        height: 40px;
        padding: 8px 10px;
        width: 100%;
    }

    .attendee-modal-card input.not-valid {
        border-color: #dc3545;
    }

    .attendees-add-button {
        border: none;
        border-radius: 50%;
        font-size: 26px;
        height: 44px;
        line-height: 1;
        min-width: 44px;
        padding: 0;
    }

    .attendees-table td,
    .attendees-table th {
        vertical-align: middle;
    }

    .attendee-icon-button {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 20px;
        padding: 0 6px;
    }

    .attendee-icon-button:hover {
        opacity: 0.7;
    }

    .attendee-certificate {
        color: #e0a800;
    }

    .attendee-edit {
        color: #1e6fd9;
    }

    .attendee-remove {
        color: #dc3545;
    }

    .question-container label {
        width: 100%;
        border-color: rgb(228, 228, 228);
        border-style: solid;
        border-width: 2px;
        border-radius: 3px;
        padding: 10px;
        margin-bottom: 5px;
    }

    .question-container hr {
        margin-top: 40px;
    }

    .question-container input {
        margin-right: 5px;
    }

    .question-container label:hover {
        width: 100%;
        cursor: pointer;
        border-color: rgb(0, 121, 188);
    }

    .question-text {
        color: black !important;
        font-size: 14px;
    }

    .question-points {
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 12px;
        color: darkred;
    }

    .question_success {
        color: darkgreen;
    }



    /*----------------------------- header --------------------------*/

    .bg-header-example-course {
        background-image: url('/wwwroot/images/course-details/header-image.png');
        height: 579px;
        background-repeat: no-repeat;
        position: relative;
    }

    .breadcrumbs-wrap .title.altered {
        font-size: 32px !important;
        font-weight: 700 !important;
    }

    /*----------------------- course detail box ---------------------*/

    .decorative-box-top {
        background-image: url('/wwwroot/images/course-details/course-detail-block.png');
        position: absolute;
        margin-right: 150px;
        background-size: contain;
        width: 305px;
        height: 24vh;
        background-repeat: no-repeat;
        right: 0px;
        padding-right: 20px;
        padding-left: 20px;
        margin-top: -90px;
    }

    .icon {
        width: 15px;
        margin-right: 5px;
    }

    .course-details-title {
        font-size: 23px;
        color: #fff;
        font-weight: 700;
        text-align: center;
        padding-bottom: 8px;
        letter-spacing: 0.1px;
        padding-top: 30px;
    }

    hr.course-detail-box-line {
        background-color: white;
        width: 40%;
        margin-top: 5px;
    }

    .course-details-icons td {
        font-size: 13px;
        color: white;
    }

    .course-details-icons {
        margin: 0 auto;
        width: 100%;
        margin-left: 7px;
    }

    /*--------------------------------- body ------------------------*/

    .example-course-page {
        background-image: url('/wwwroot/images/course-details/background-main.jpg');
        margin-top: -120px;
        padding-bottom: 340px;
    }

    .my-container {
        background-color: white;
        box-shadow: 0px 0px 76px #d8d8d840;
        border-radius: 10px;
        border: 1px solid #F1F1F1;
    }

    /*--------------------index-navigation--column ------------------------*/

    #collapsable {
        transition: all 0.4s ease-in-out;
        -webkit-transition: all 0.4s ease-in-out;
        -moz-transition: all 0.4s ease-in-out;
        background-color: #fafafd;
        position: relative;
        left: 15px;
        padding-right: 0px;
    }

    #modules-toggle {
        padding-left: 30px;
    }

    #number-2, #number-3, #number-4 {
        display: none;
    }

    .col-lg-3.no-padding-left, .container.no-padding-left {
        padding-left: 0px !important;
    }

    .course-contents-title-class {
        background-color: #FBB545;
        font-size: 18px;
        text-transform: uppercase;
        border-bottom: 1px solid #e1e1e3;
        padding: 20px 40px;
        color: white;
        font-weight: 600;
    }

    h2.module-title-selected {
        color: #FBB545;
        font-size: 18px;
        font-weight: 500;
        padding: 5px 0px 0px;
        cursor: pointer;
    }

    .module-title-non-selected {
        color: #7A7A7A;
        font-size: 18px;
        font-weight: 400;
        padding: 5px 0px 0px;
        cursor: pointer;
    }

        .module-title-non-selected:hover {
            color: #fbb545;
        }

    .page-name {
        color: inherit;
        text-decoration: none;
        font-size: 12px !important;
        cursor: pointer;
        margin-left: 10px;
    }

        .page-name:hover {
            color: #fbb545;
        }

    li.lesson-number {
        color: #333333;
        font-size: 13px !important;
        padding: 0px 0px 5px 0px;
    }

    li.lesson-title a {
        font-size: 12px !important;
    }

    #lesson-1-module-1-link {
        color: #fbb545;
    }

    .lesson-box.lesson-2, .lesson-box.lesson-3, .lesson-box.lesson-4 {
        display: none;
    }

    .lesson-box {
        width: 25px;
    }

    hr.module-dividing-line {
        border-top: 1px solid rgb(165 165 165 / 10%) !important;
        margin: 1rem auto !important;
        width: 85% !important;
    }

    .chapter h1 {
        font-size: 18px;
        text-transform: uppercase;
        color: #8a8a8a;
        padding: 20px 40px;
        font-weight: 600;
    }

    .chapter-disabled {
        font-size: 18px;
        text-transform: uppercase;
        color: #8a8a8a;
        padding: 20px 40px;
        font-weight: 600;
        font-size: 18px;
        font-weight: 600;
        background-color: #f7f7fb;
        cursor: pointer;
    }

    /*-------------------------------content--column --------------------------*/

    .module-section {
        padding: 0px 0px 10px 15px;
    }

    #lesson-content-section {
        padding-left: 25px;
        padding-right: 25px;
    }

    .content-page-wrap {
        border-bottom: 1px solid #eaeaea;
        width: 90%;
        margin: 0 auto;
        margin-bottom: 25px;
    }

    /*------------------------next and previous arrow section -------------------------*/

    a.previous-arrow-text, a.next-arrow-text {
        color: #333333;
        font-weight: 500;
    }

    .previous-arrow-img {
        width: 25px;
        margin: 20px 10px 20px 0px;
    }

    .next-arrow-img {
        width: 25px;
        margin: 20px 0px 20px 10px;
    }

    .previous-arrow-container {
        float: left;
    }

    .next-arrow-container {
        float: right;
    }

        .next-arrow-container:hover, .previous-arrow-container:hover {
            cursor: pointer;
            color: #fbb545;
        }
    /*-------------------------paragraph text styling -----------------------*/

    p.lesson-paragraph-1, p.lesson-paragraph-2, p.lesson-2-paragraph-1, p.lesson-paragraph-3 {
        font-weight: 300;
        font-size: 16px;
        line-height: 1.7;
        margin-left: 20px;
    }

    #lesson-2-module1-section, #quiz-test-1 {
        display: none;
    }

    #section-2-video {
        margin: 0 auto;
        width: 95%;
        display: block;
        margin-top: 45px;
        box-shadow: 0px 0px 76px #d0d0d059;
        margin-bottom: 50px;
    }

    p.lesson-paragraph-3 {
        margin-left: 0px !important;
    }

        p.lesson-paragraph-3.lesson-3-altered {
            font-weight: 500 !important;
            font-size: 17px !important;
            padding-top: 35px;
            padding-bottom: 45px;
        }

    p.lesson-2-paragraph-1 {
        margin-right: 10px;
    }

    p.lesson-paragraph-1, p.lesson-2-paragraph-1 {
        padding-top: 15px;
    }

    h3.lesson-title {
        color: #FBB545;
        margin-left: 20px;
        padding-top: 10px;
        font-weight: 600;
    }

    p.lesson-paragraph-special {
        border-left: 4px solid #3f4c99;
        padding-top: 0px;
        padding-left: 15px;
        margin-left: 100px;
        font-style: italic;
        margin-top: 45px;
        margin-bottom: 30px;
        margin-right: 60px;
        font-weight: 400;
        font-size: 14px;
        line-height: 1.5;
    }

    .lesson-3-text {
        padding: 35px 0px 10px 15px;
    }

    p.lesson-paragraph-2 {
        padding-top: 35px;
        padding-bottom: 35px;
    }


    ul.list-1 {
        list-style: none;
        margin-left: 25px;
        padding-top: 25px;
        margin-right: 35px;
        font-size: 14px !important;
        font-style: italic;
    }

    ul.list-2 {
        list-style: none;
        margin-left: 45px;
        padding-top: 10px;
        font-size: 15px !important;
        font-weight: 300;
        padding-bottom: 35px;
        margin-right: 45px;
    }

        ul.list-1 li, ul.list-2 li {
            padding-left: 20px;
            position: relative;
            line-height: 1.6;
            padding-top: 15px;
        }

            ul.list-1 li:before, ul.list-2 li:before {
                content: "•";
                color: #FBB545;
                position: absolute;
                left: 0em;
            }

    #section-1-video {
        transition: all 0.4s ease-in-out;
        -webkit-transition: all 0.4s ease-in-out;
        -moz-transition: all 0.4s ease-in-out;
        width: 95%;
        margin: 0 auto;
        display: block;
        margin-top: 35px;
        box-shadow: 0px 0px 76px #d0d0d059;
    }

    .image-1-lesson-1 {
        padding-top: 45px;
    }

    .img-lesson-4 {
        margin: 0 auto;
        width: 95%;
        display: block;
        margin-top: 35px;
        box-shadow: 0 1px 1px rgba(16,27,30,0.15), 0 2px 2px rgba(16,27,30,0.15), 0 4px 4px rgba(16,27,30,0.15), 0 8px 8px rgba(16,27,30,0.15), 0 16px 16px rgba(16,27,30,0.15);
        margin-bottom: 60px;
    }

    li.lesson-title {
        margin-top: 5px;
        margin-bottom: 5px;
        margin-left: 15px;
    }

        li.lesson-title a {
            margin-left: 10px;
        }
</style>

<script>
    import MixinsCertificates from '../../mixinsCertificates';
    import PDFJSViewer from '../../components/PDFJSViewer';
    import ScormViewer from '../../components/ScormViewer';

    export default {
        name: 'CourseDetails',
        mixins: [MixinsCertificates],
        components: {
            PDFJSViewer,
            ScormViewer
        },
        props: {

        },
        data: function () {
            return {
                course: null,
                courseDetails: null,
                showSubmissionError: false,
                confirmationPage: null,
                currentPageIndex: 0,
                currentChapterIndex: 0,
                scormComponent: null,
                attendees: [],
                attendeeModalOpen: false,
                attendeeForm: {
                    id: 0,
                    courseId: parseInt(this.$route.params.id),
                    name: "",
                    surname: "",
                    company: "",
                    facilitySite: "",
                    email: "",
                    number: "",
                    employeeId: "",
                    idNumber: "",
                    date: new Date().toISOString().split("T")[0]
                },
                attendeeValidation: {
                    name: false,
                    surname: false,
                    company: false,
                    date: false
                }
            }
        },
        computed: {
            hasCertificate() {
                return !!this.courseDetails && !!this.courseDetails.certificateProperties && this.courseDetails.certificateProperties.length > 0;
            },
            courseId() {
                // We will see what `params` is shortly
                return this.$route.params.id;
            },
            jwt() {
                return this.$store.state.jwt;
            },
            user() {
                return this.$store.state.user;
            },
            isCourseFacilitated() {
                return this.course && this.course.isFacilitated === true;
            },
        },
        methods: {
            emptyAttendeeForm() {
                return {
                    id: 0,
                    courseId: parseInt(this.$route.params.id),
                    name: "",
                    surname: "",
                    company: "",
                    facilitySite: "",
                    email: "",
                    number: "",
                    employeeId: "",
                    idNumber: "",
                    date: new Date().toISOString().split("T")[0]
                };
            },
            formatDate(value) {
                if (!value) {
                    return "";
                }

                return value.toString().split("T")[0];
            },
            async loadAttendees() {
                if (!this.isCourseFacilitated) {
                    this.attendees = [];
                    return;
                }

                this.attendees = await this.web("/courses/attendees/" + this.courseId, "Loading attendees");
            },
            openAttendeeModal(attendee) {
                this.attendeeValidation = {
                    name: false,
                    surname: false,
                    company: false,
                    date: false
                };

                if (attendee) {
                    this.attendeeForm = {
                        id: attendee.id,
                        courseId: attendee.courseId,
                        name: attendee.name || "",
                        surname: attendee.surname || "",
                        company: attendee.company || "",
                        facilitySite: attendee.facilitySite || "",
                        email: attendee.email || "",
                        number: attendee.number || "",
                        employeeId: attendee.employeeId || "",
                        idNumber: attendee.idNumber || "",
                        date: this.formatDate(attendee.date) || new Date().toISOString().split("T")[0]
                    };
                }
                else {
                    this.attendeeForm = this.emptyAttendeeForm();
                }

                this.attendeeModalOpen = true;
            },
            closeAttendeeModal() {
                this.attendeeModalOpen = false;
                this.attendeeForm = this.emptyAttendeeForm();
            },
            validateAttendee() {
                this.attendeeValidation = {
                    name: !this.attendeeForm.name || this.attendeeForm.name.trim() === "",
                    surname: !this.attendeeForm.surname || this.attendeeForm.surname.trim() === "",
                    company: !this.attendeeForm.company || this.attendeeForm.company.trim() === "",
                    date: !this.attendeeForm.date
                };

                return !this.attendeeValidation.name && !this.attendeeValidation.surname && !this.attendeeValidation.company && !this.attendeeValidation.date;
            },
            async saveAttendee() {
                if (!this.validateAttendee()) {
                    return;
                }

                await this.web("/courses/attendees", "Saving attendee", this.attendeeForm);
                this.closeAttendeeModal();
                await this.loadAttendees();
            },
            async removeAttendee(attendee) {
                if (!confirm("Remove this attendee?")) {
                    return;
                }

                await this.web("/courses/attendees/delete/" + attendee.id, "Removing attendee", {});
                await this.loadAttendees();
            },
            canNavigateBy(number) {
                console.log("canNavigateBy");
                var newChapter = this.currentChapterIndex;
                var newPage = this.currentPageIndex + number;

                if (newPage < 0) {
                    newChapter = newChapter - 1;
                    newPage = 0;
                }

                if (newChapter < 0) {
                    return false; //we're at the first chapter
                }

                if (this.courseDetails.chapters.length > 0 && this.courseDetails.chapters[newChapter].pages.length > 0)
                    if (newPage >= this.courseDetails.chapters[newChapter].pages.length) {
                        newPage = 0;
                        newChapter = newChapter + 1;
                    }

                if (newChapter >= this.courseDetails.chapters.length) {
                    return false;//we're at the last chapter
                }

                return true;
            },
            navigateBy(number) {
                console.log("navigateBy");
                var newChapter = this.currentChapterIndex;
                var newPage = this.currentPageIndex + number;

                if (newPage < 0) {
                    newChapter = newChapter - 1;
                    newPage = this.courseDetails.chapters[newChapter].pages.length - 1;
                }

                if (newPage >= this.courseDetails.chapters[newChapter].pages.length) {
                    newPage = 0;
                    newChapter = newChapter + 1;
                }

                this.changeSelection(newChapter, newPage);
            },
            async changeSelection(chapterIdx, pageIdx) {
                console.log("changeSelection", chapterIdx, pageIdx);
                this.currentChapterIndex = chapterIdx;
                this.currentPageIndex = pageIdx;

                //update annotations
                if ($("#content-section")[0]) {
                    $("#content-section")[0].scrollIntoView();

                    setTimeout(function () {
                        $('.annotation').each(function (i, e) {

                            var targetId = $(e).attr("target-id");
                            var htmlContent = $("#" + targetId).html();

                            $(e).tipso({
                                useTitle: true,
                                titleContent: 'Annotation',
                                content: htmlContent,
                                size: "small",
                                maxWidth: 400,
                            });

                        });
                    }, 1000);
                }

                var chapter = this.courseDetails.chapters[this.currentChapterIndex];
                if (chapter) {
                    var currentPage = chapter.pages[this.currentPageIndex];
                    if (currentPage && !currentPage.hasQuestions && !currentPage.userCompleted) {

                        await this.web("/courses/PageState", "Updating your progress", {
                            courseId: parseInt(this.courseId),
                            page: currentPage
                        });

                        currentPage.userCompleted = true;
                    }
                }

            },
            submit(page) {
                console.log("submit");
                //check if there are no errors
                
                for (var c = 0; c < page.components.length; c++) {
                    var component = page.components[c];

                    if (component.totalPoints > 0 && component.userAnswerIndexes.length !== component.totalPoints) {
                        this.showSubmissionError = true;
                        return;
                    }
                }

                this.confirmationPage = page;
            },
            async confirmSubmit() {
                console.log("confirmSubmit");
                var page = this.confirmationPage;
                this.confirmationPage = null;
                await this.web("/courses/PageState", "Processing your submission", {
                    courseId: parseInt(this.courseId),
                    page: page
                });

                var result = await this.web("/courses/details/" + this.courseId, "Refreshing your page");
                this.course = result.course;
                this.courseDetails = result.details;
            },
            async downloadCertificate() {
                console.log("downloadCertificate");
                console.log("Building");
                var pdfBytes = await this.generateCertificate(this.course, this.courseDetails, this.user);

                console.log("Downloading PDF");
                var bytes = new Uint8Array(pdfBytes); // pass your byte response to this constructor
                var blob = new Blob([bytes], { type: "application/pdf" });// change resultByte to bytes

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "Certificate.pdf";
                link.click();
            },
            async downloadAttendeeCertificate(attendee) {
                var pdfBytes = await this.generateCertificate(this.course, this.courseDetails, null, attendee);
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([new Uint8Array(pdfBytes)], { type: "application/pdf" }));
                link.download = `Certificate-${attendee.name}-${attendee.surname}.pdf`;
                link.click();
            },
            selectScormComponent(component) {
                console.log("selectScormComponent");
                this.scormComponent = component;
            },
            async reloadCourse() {
                //load courses 
                console.log("reloadCourse");
                this.scormComponent = null;

                var result = await this.web("/courses/details/" + this.courseId);

                this.course = result.course;
                this.courseDetails = result.details;
            }
        },
        async mounted() {

            if (window.location.href.indexOf("#enrol") > -1) {
                await this.web('/cart/enrol', "Enrolling you...", { id: this.courseId });
                this.$router.replace(`/courses/details/${this.courseId}`);
            }

            var result = await this.web("/courses/details/" + this.courseId, "Loading course details");

            this.course = result.course;
            this.courseDetails = result.details;
            await this.loadAttendees();

            if (window.location.hash.indexOf("#certificate") > -1) {
                this.changeSelection(-1, 0);
            }
            else {
                this.changeSelection(0, 0);
            }

            var crumbs = {};
            crumbs["/dashboard"] = "Dashboard";
            crumbs["/courses/details/" + this.courseId] = this.course.name;
            this.$store.commit("breadCrumbs", crumbs);
        }
    }

</script>
